// ** React Imports
// ** Utils
import { canViewMenuGroup, canViewMenuItem } from "@layouts/utils";
import Query from "@query";
// ** Ability Context
import { AbilityContext } from "@src/utility/context/Can";
import { useContext, useEffect, useState } from "react";
// ** Vertical Menu Components
import { useSelector } from "react-redux";
import VerticalNavMenuGroup from "./VerticalNavMenuGroup";
import VerticalNavMenuLink from "./VerticalNavMenuLink";
import VerticalNavMenuLinkWallet from "./VerticalNavMenuLinkWallet";
import VerticalNavMenuSectionHeader from "./VerticalNavMenuSectionHeader";

const VerticalMenuNavItems = (props) => {
  // ** Context
  const ability = useContext(AbilityContext);

  const store = useSelector((state) => state.wallet);

  const query = new Query();

  const [holdings, setHoldings] = useState({});
  const [pricing, setPricing] = useState({});

  useEffect(() => {
    const fetchHoldings = async () => {
      // console.log("checking", store.address, store.tokens);
      if (!store.address || !store.tokens || store.tokens.length < 1) {
        return;
      }

      const holdings = await query.getBalances(store.address, store.tokens).catch((e) => {
        console.log(e);
      });
      // console.log("holdings", holdings);
      setHoldings(holdings);

      const pricing = await query.getPrice(store.tokens.filter((t) => t.contractAddress in holdings && holdings[t.contractAddress] > 0));
      setPricing(pricing);
    };
    fetchHoldings();
  }, [store.address, store.tokens]);

  // ** Components Object
  const Components = {
    VerticalNavMenuSectionHeader,
    VerticalNavMenuGroup,
    VerticalNavMenuLink,
    VerticalNavMenuLinkWallet,
  };

  const pleaseConnect = {
    id: "pleaseConnect",
    title: "Please Connect Wallet",
    navLink: "#",
  };

  const items = [
    {
      id: "wallet",
      header: "Wallet",
    },
  ];

  if (!store.address || !store.tokens || store.tokens.length < 1) {
    items.push(pleaseConnect);
  } else {
    const entries = store.tokens
      .map((t) => {
        let price = 0.0;
        let holding = 0.0;
        if (t.contractAddress in holdings) {
          holding = holdings[t.contractAddress];
        }
        if (t.contractAddress in pricing && !isNaN(pricing[t.contractAddress].priceBnb)) {
          price = pricing[t.contractAddress].priceBnb * store.bnbPrice;
        }
        return {
          id: `balance_${t.contractAddress}`,
          title: t.tokenSymbol,
          amount: holding || "",
          value: price * holding,
          navLink: `/tokens/${t.contractAddress}`,
        };
      })
      .filter((e) => e.value > 0.01);
    entries.sort((x, y) => -x.value + y.value);

    items.push(...entries);
  }

  // ** Render Nav Menu Items
  const RenderNavItems = items.map((item, index) => {
    const TagName = Components[item.header ? "VerticalNavMenuSectionHeader" : item.id === "pleaseConnect" ? "VerticalNavMenuLink" : "VerticalNavMenuLinkWallet"];
    if ("element" in item) {
      return item.element;
    }
    if (item.children) {
      return canViewMenuGroup(item) && <TagName item={item} index={index} key={item.id} {...props} />;
    }
    return canViewMenuItem(item) && <TagName key={item.id || item.header} item={item} {...props} />;
  });

  return RenderNavItems;
};

export default VerticalMenuNavItems;
